import type {ComponentType} from 'react'
import {createContext, useContext} from 'react'

interface AuthenticationDialogProps {
  authenticationMode: 'signIn' | 'signUp' | 'resetPassword' | null,
  onClose: () => void
}

export interface CustomizationConfig {
  siteIcon: string;
  siteTitle: string;
  dedicatedOrganization?: string;
  ReceptionPage: ComponentType;
  AuthenticationDialog?: ComponentType<AuthenticationDialogProps>;
}

export const CustomGoSchoolContext = createContext<CustomizationConfig | undefined>(undefined)

export function useCustomizationConfig() {
  const context = useContext(CustomGoSchoolContext)
  if (!context) {
    throw new Error('useCustomGoSchool must be used within a CustomGoSchoolContextProvider')
  }
  return context
}
